import { Registry } from "@/shared/infra/dependency-injection/registry";

export function useInject<T>(name: string): T {
  return Registry.getInstance().inject<T>(name);
}
